/* eslint-disable prettier/prettier */
export const getApiErrorMessage = (err: any): string => {
	return (
		err?.response?.data?.details?.message || // ✅ best message
		err?.response?.data?.message || // fallback
		err?.message || // JS error
		'Something went wrong'
	);
};
